import { render, staticRenderFns } from "./DialogSendLocation.vue?vue&type=template&id=98674b5a&scoped=true&"
import script from "./DialogSendLocation.vue?vue&type=script&lang=ts&"
export * from "./DialogSendLocation.vue?vue&type=script&lang=ts&"
import style0 from "./DialogSendLocation.vue?vue&type=style&index=0&id=98674b5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98674b5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VImg,VRow,VSheet})
